import type { SingleBillInfoFormPageStore } from '@ctct/state-client-layer';
import { createSingleBillInfoFormSliceDefaultValues } from '@ctct/state-client-layer';

import type { SingleBillInfoFormValues } from '../types';

export class FormMountService {
  constructor(
    private pageStore: SingleBillInfoFormPageStore,
    private getDefaultValues: () => SingleBillInfoFormValues,
    private validate: (values: SingleBillInfoFormValues) => boolean
  ) {}

  public api() {
    return {
      resetState: () => this.initState(),

      allRequiredFieldsAreFilledWithDefaultValues: () => {
        return this.allRequiredFieldsAreFilledWithDefaultValues();
      },
    };
  }

  public data() {
    return {};
  }

  public handlers() {
    return {};
  }

  public initState = () => {
    const initState = createSingleBillInfoFormSliceDefaultValues();

    const allRequiredFieldsAreFilled = this.allRequiredFieldsAreFilledWithDefaultValues();

    if (!allRequiredFieldsAreFilled) {
      initState.canDisplayCard = false;
      initState.isDisplayingCard = false;
    }

    this.pageStore.setState(initState);
  };

  private allRequiredFieldsAreFilledWithDefaultValues() {
    return this.validate(this.getDefaultValues());
  }
}
